import { axios } from '@/utils/request'
import { message as Message } from 'ant-design-vue'

const api = {
  user: '/api/user',
  role: '/api/role',
  service: '/api/service',
  permission: '/api/permission',
  permissionNoPager: '/api/permission/no-pager'
}

export default api

//post
export function postAction(url,parameter) {
  return axios({
    url: url,
    method:'post' ,
    data: parameter
  })
}

//post method= {post | put}
export function httpAction(url,parameter,method,headers={}) {
  return axios({
    url: url,
    method:method ,
    data: parameter,
    headers
  })
}

//put
export function putAction(url,parameter,headers={}) {
  return axios({
    url: url,
    method:'put',
    data: parameter,
    headers
  })
}

//get
export function getAction(url,parameter) {
  return axios({
    url: url,
    method: 'get',
    params: parameter
  })
}

//deleteAction
export function deleteAction(url,parameter,headers={}) {
  return axios({
    url: url,
    method: 'delete',
    params: parameter,
    headers
  })
}

export function getUserList(parameter) {
  return axios({
    url: api.user,
    method: 'get',
    params: parameter
  })
}

export function getRoleList(parameter) {
  return axios({
    url: api.role,
    method: 'get',
    params: parameter
  })
}

export function getServiceList(parameter) {
  return axios({
    url: api.service,
    method: 'get',
    params: parameter
  })
}

export function getPermissions(parameter) {
  return axios({
    url: api.permissionNoPager,
    method: 'get',
    params: parameter
  })
}

// id == 0 add     post
// id != 0 update  put
export function saveService(parameter) {
  return axios({
    url: api.service,
    method: parameter.id == 0 ? 'post' : 'put',
    data: parameter
  })
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url,parameter,method='get'){
  if(!parameter){
    parameter={}
  }
  return axios({
    url: url,
    [method === 'get' ? 'params' : 'data']: parameter,
    method: method,
    responseType: 'blob'
  })
}

export function  downloadFile(fileName,url,param,method='get'){
  //console.log('导出参数', param)
  return downFile(url, param, method).catch((error) => {
    const data = error.response && error.response.data
    if (data && data.type && data.type.includes('json')) return data
    throw error
  }).then((data) => {
    if (!data) {
      Message.error('文件下载失败')
      return
    }
    // blob为json时是后端报错信息, 解析后提示
    if (data.type && data.type.includes('json')) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const result = JSON.parse(reader.result)
            Message.error(result.message || result.msg || '操作失败')
          } catch (e) {
            Message.error('文件下载失败')
          }
          resolve()
        }
        reader.onerror = () => {
          Message.error('文件下载失败')
          resolve()
        }
        reader.readAsText(data)
      })
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data]), fileName )
    } else {
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName )
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(url) //释放掉blob对象
    }
  })
}

